<!-- opções projetadas (invisíveis, servem só de fonte de dados) -->
<ng-content></ng-content>

<ion-input type="text" class="outline full select-trigger" [class.select-expanded]="IsOpen" [disabled]="IsDisabled"
    [value]="SelectedLabel" (click)="OpenPopover($event)" readonly [placeholder]="Placeholder">
    <ion-icon name="chevron-down-outline"></ion-icon>
</ion-input>

<ion-popover #popover [isOpen]="IsOpen" (didDismiss)="IsOpen = false" (didPresent)="FocusSearch()" class="select-search ss-popover">
    <ng-template>
        <ion-header *ngIf="ShowSearch" class="ss-header">
            <ion-toolbar>
                <ion-searchbar #search placeholder="pesquisar" [value]="SearchText"
                    (ionInput)="OnSearch($event)" (keydown)="OnKeyDown($event)"></ion-searchbar>
            </ion-toolbar>
        </ion-header>
        <ion-content #popContent [scrollY]="false" class="ion-no-padding" tabindex="0"
            (keydown)="OnKeyDown($event)">
            <cdk-virtual-scroll-viewport class="ss-viewport ion-content-scroll-host" itemSize="40" minBufferPx="750"
                maxBufferPx="1360" [style.height.px]="ViewportHeight">
                <ion-radio-group *ngIf="!multiple" [value]="value" [compareWith]="compareWith">
                    <ng-container *cdkVirtualFor="let item of FilteredOptions; trackBy: trackByFn">
                        <ion-item lines="none" class="ss-option" [class.selected]="IsSelected(item)"
                            [class.active]="IsActive(item)" [class.disabled]="item?.disabled"
                            (click)="OnItemClick(item)">
                            <ion-radio [value]="item?.value" [disabled]="item?.disabled" justify="space-between"
                                label-placement="start" class="ss-radio">
                                <span class="ss-label">{{ item?.label || '--' }}</span>
                            </ion-radio>
                            <ion-icon *ngIf="IsSelected(item)" slot="end" name="checkmark-outline" class="ss-check"
                                aria-hidden="true"></ion-icon>
                        </ion-item>
                    </ng-container>
                </ion-radio-group>

                <ng-container *ngIf="multiple">
                    <ng-container *cdkVirtualFor="let item of FilteredOptions; trackBy: trackByFn">
                        <ion-item lines="none" class="ss-option" [class.selected]="IsSelected(item)"
                            [class.active]="IsActive(item)" [class.disabled]="item?.disabled"
                            (click)="OnItemClick(item)">
                            <ion-checkbox [checked]="IsSelected(item)" [disabled]="item?.disabled" justify="space-between"
                                label-placement="start" class="ss-radio">
                                <span class="ss-label">{{ item?.label || '--' }}</span>
                            </ion-checkbox>
                            <ion-icon *ngIf="IsSelected(item)" slot="end" name="checkmark-outline" class="ss-check"
                                aria-hidden="true"></ion-icon>
                        </ion-item>
                    </ng-container>
                </ng-container>
                <div class="ss-empty" *ngIf="FilteredOptions?.length == 0">sem resultados</div>
            </cdk-virtual-scroll-viewport>
        </ion-content>
    </ng-template>
</ion-popover>
